import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState, AUTH_TAG } from './auth.state';

const AuthSelector = createFeatureSelector<AuthState>(AUTH_TAG);

export const getAuthenticationToken = createSelector(AuthSelector, (state: AuthState) => state.authenticationToken);
export const getAuthenticatedUserData = createSelector(AuthSelector, (state: AuthState) => state.userData);
export const getAuthError = createSelector(AuthSelector, (state: AuthState) => state.authError);
